import React from 'react';
import Select from 'react-select';

class SmartSelectClearable extends React.Component {
    constructor(props) {
        super(props);
        this.SmartSelectRef = React.createRef();
        var labelVal = this.getLabel(this.props.values, this.props.node.data[this.props.colDef.field]);
        this.state = {
            values: props.values,
            selectedValue: { label: labelVal, value: this.props.node.data[this.props.colDef.field] }
        };
    };

    isPopup() {
        return typeof this.props.isPopup === "boolean" ? this.props.isPopup : false;
    }

    getLabel(values, selectedValue) {
        if (selectedValue === null || selectedValue === undefined || values === undefined || values === null || !values.find(x => x.value === selectedValue))
            return null;
        return values.find(x => x.value === selectedValue).label;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({ values: nextProps.values });
    };

    render() {
        return (
            <div style={{ width: this.isPopup() ? this.props.column.getActualWidth() : "100%", display: "relative" }}>
                <div className="dropdown smart-select-dropdown" >
                    <div  >
                        <Select
                            options={this.props.values}
                            value={this.state.selectedValue}
                            onChange={(selected) => {
                                let selectedItem = {
                                    label: '',
                                    value: ''
                                };

                                if (selected) {
                                    selectedItem = selected;
                                    this.props.node.setDataValue(this.props.colDef.field, selected.value);
                                }
                                else {
                                    this.props.node.setDataValue(this.props.colDef.field, '');
                                }
                                this.setState({ selectedValue: selectedItem });
                            }}
                            className='react-select-button'
                            menuColor='red'
                            isClearable={true}
                        />
                    </div>
                </div>
            </div>


        );
    };
};

export default SmartSelectClearable;